"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, type ReactNode } from "react";
import { useAuthenticatedContent } from "../../../hooks/useAuthenticatedContent";
import useDeviceInfo from "../../../hooks/useDeviceInfo";
import UserSetUpProfileCta from "../../user/utils/set-up-profile/UserSetUpProfileCta";
import WavesDesktop from "../WavesDesktop";
import WavesMobile from "../WavesMobile";
function getConnectPrompt(contentState: ReturnType<typeof useAuthenticatedContent>["contentState"]): ReactNode {
  switch (contentState) {
    case "needs-profile":
      return <>
          <h1 className="tw-text-xl tw-font-bold">
            You need to set up a profile to continue.
          </h1>
          <UserSetUpProfileCta />
        </>;
    case "not-available":
      return <h1 className="tw-text-xl tw-font-bold">
          This content is not available.
        </h1>;
    case "loading":
    case "measuring":
    case "not-authenticated":
    case "ready":
    default:
      return null;
  }
}
function getWavesContent({
  children,
  containerClassName,
  isApp
}: {
  readonly children: ReactNode;
  readonly containerClassName: string;
  readonly isApp: boolean;
}): ReactNode {
  const Component = isApp ? WavesMobile : WavesDesktop;
  return <div className="tw-flex-1" id="waves-content">
      <Component>
        <div className={containerClassName}>{children}</div>
      </Component>
    </div>;
}

// Main layout content that uses the Layout context
function WavesLayoutContent(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    contentState
  } = useAuthenticatedContent();
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== contentState) {
    t2 = getConnectPrompt(contentState);
    $[1] = contentState;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const connectPrompt = t2;
  let content;
  if (contentState === "ready" || contentState === "not-authenticated") {
    let t3;
    if ($[3] !== children || $[4] !== isApp) {
      t3 = getWavesContent({
        children,
        containerClassName: "tw-relative tw-flex tw-flex-col tw-flex-1 tailwind-scope",
        isApp
      });
      $[3] = children;
      $[4] = isApp;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    content = t3;
  } else {
    let t3;
    if ($[6] !== connectPrompt) {
      t3 = connectPrompt === null ? null : <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-px-6"><div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-text-center">{connectPrompt}</div></div>;
      $[6] = connectPrompt;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    content = t3;
  }
  let t3;
  if ($[8] !== content) {
    t3 = <div className="tailwind-scope tw-flex tw-flex-col tw-overflow-hidden tw-bg-black">{content}</div>;
    $[8] = content;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp() {
  const previousBodyOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  return () => {
    document.body.style.overflow = previousBodyOverflow;
  };
}
export default function WavesLayout(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <WavesLayoutContent>{children}</WavesLayoutContent>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}